export const baseTheme = {
  colors: {
    primary_color: "#2A95BF",
    secondary_color: "#11364E",
    third_color: "#473974",
    fourth_color: "#737373",
    fifth_color: "#a19f9f",
    sixth_color: "#005475",
    black: "#000",
    white: "#fff",
  },

  box: {
    boxShadow: "rgba(0,0,0,0.19) 0 5px 5px, rgba(0,0,0,0.23) 0 6px 8px;",
  },

  media: {
    mobile_min: "375px",
    mobile_max: "576px",
    mobile_border_max: "767px",
    tablet_min: "768px",
    tablet_max: "991px",
    desktop_min: "992px",
    desktop_md: "1024px",
    wideScreen_min: "1200px",
    wideScreen_xl: "1440px",
    wideScreen_max: "1800px",
  },

  durations: {
    transition: "0.3s ease-in-out",
    transition_slow: "all 0.45s ease-in-out",
  },

  fonts: {
    primary_font: "Montserrat, sans-serif",
  },
  paragraphs: {
    p: {
      fontSize: "14px",
      lineHeight: "20px",
      fontWeight: "400",
      color: "white",

      "@media (min-width: 768px)": {
        fontSize: "20px",
        lineHeight: "32px",
      },
    },
  },
  container: {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 15px",
    boxSizing: "border-box",

    "@media (min-width: 1024px)": {
      padding: "0 15px",
    },
  },

  primaryButton: {
    padding: "13px 28px",
    color: "#fff",
    backgroundColor: "#2A95BF",
    fontSize: "16px",
    lineHeight: "20px",
    fontWeight: 500,
    border: "none",
    display: "inline-block",
    transition: ".3s ease-in-out",

    "@media (min-width: 768px)": {
      fontSize: "24px",
      lineHeight: "26px",
    },

    a: {
      color: "#fff",
    },

    "&:hover": {
      transition: ".3s ease-in-out",
      backgroundColor: "#11364E",
    },
  },
}
